<template>
    <table class="soil-report-results">
        <thead>
        <tr>
            <th class="bg-transparent border-top-0 border-right-0 border-left-0" colspan="2">&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr class="text-uppercase text-center">
            <td class="bg-primary-color border-bottom-2 text-bold">Lab Number</td>
            <td class="bg-primary-color border-bottom-2 text-bold">Sample<br>Identification</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-2">{{ sample.id || '&nbsp;' }}</td>
            <td class="border-bottom-2">{{ sample.client_id }}</td>
        </tr>
        <tr>
            <td class="border-bottom-2 border-left-0 border-right-0" colspan="2">&nbsp;</td>
        </tr>
        <tr class="text-center">
            <td class="text-uppercase border-bottom-2 bg-primary-color">
                <div class="text-bold">Analyte</div>
                <div class="sub-header">(Method)</div>
            </td>
            <td class="text-uppercase border-bottom-2 bg-primary-color text-bold">Result</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Organic Matter (%)</div>
                <div class="sub-header">L.O.I.</div>
            </td>
            <td class="border-bottom-1">{{ getResult('OM') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Nitrate-N (ppm)</div>
                <div class="sub-header">FIA</div>
            </td>
            <td class="border-bottom-1">{{ getResult('NO3') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Subsoil NO<sub>3</sub>-N (ppm)</div>
                <div class="sub-header">FIA</div>
            </td>
            <td class="border-bottom-1">{{ getResult('sub1_NO3_LBS') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Subsoil NO<sub>3</sub>-N (ppm)</div>
                <div class="sub-header">FIA</div>
            </td>
            <td class="border-bottom-1">{{ getResult('sub2_NO3_LBS') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">P<sub>1</sub> Phosphorus (ppm)</div>
                <div class="sub-header">WEAK BRAY (1:7)</div>
            </td>
            <td class="border-bottom-1">{{ getResult('P1') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">P<sub>2</sub> Phosphorus (ppm)</div>
                <div class="sub-header">STRONG BRAY (1:7)</div>
            </td>
            <td class="border-bottom-1">{{ getResult('P2') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Bicarbonate P (ppm)</div>
                <div class="sub-header">Olsen</div>
            </td>
            <td class="border-bottom-1">{{ getResult('BICARB') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Potassium (ppm)</div>
                <div class="sub-header">Neutral NH<sub>4</sub> Acetate (Exchangeable)</div>
            </td>
            <td class="border-bottom-1">{{ getResult('K') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Magnesium (ppm)</div>
                <div class="sub-header">Neutral NH<sub>4</sub> Acetate (Exchangeable)</div>
            </td>
            <td class="border-bottom-1">{{ getResult('MG') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Sulfur (ppm)</div>
                <div class="sub-header">ICP</div>
            </td>
            <td class="border-bottom-1">{{ getResult('S') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div>Zinc (ppm)</div>
                <div class="sub-header">DTPA Extraction</div>
            </td>
            <td class="border-bottom-1">{{ getResult('ZN') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Manganese (ppm)</div>
                <div class="sub-header">DTPA Extraction</div>
            </td>
            <td class="border-bottom-1">{{ getResult('MN') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Iron (ppm)</div>
                <div class="sub-header">DTPA Extraction</div>
            </td>
            <td class="border-bottom-1">{{ getResult('FE') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Copper (ppm)</div>
                <div class="sub-header">DTPA Extraction</div>
            </td>
            <td class="border-bottom-1">{{ getResult('CU') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Boron (ppm)</div>
                <div class="sub-header">DTPA Extraction</div>
            </td>
            <td class="border-bottom-1">{{ getResult('B') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">CEC (meq/100g)</div>
                <div class="sub-header">&nbsp;</div>
            </td>
            <td class="border-bottom-1">{{ getResult('CEC') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">pH</div>
                <div class="sub-header">1:1</div>
            </td>
            <td class="border-bottom-1">{{ getResult('PH') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Buffer Index</div>
                <div class="sub-header">&nbsp;</div>
            </td>
            <td class="border-bottom-1">{{ getResult('BPH') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Calcium (ppm)</div>
                <div class="sub-header">Neutral NH<sub>4</sub> Acetate (Exchangeable)</div>
            </td>
            <td class="border-bottom-1">{{ getResult('CA') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Sodium (ppm)</div>
                <div class="sub-header">Neutral NH<sub>4</sub> Acetate (Exchangeable)</div>
            </td>
            <td class="border-bottom-1">{{ getResult('NA') }}</td>
        </tr>
        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Excess Lime Rate</div>
                <div class="sub-header">&nbsp;</div>
            </td>
            <td class="border-bottom-1">{{ getResult('EXCESS_LIME') }}</td>
        </tr>

        <tr class="text-center">
            <td class="border-bottom-1">
                <div class="text-bold">Soluble Salts (mmhos/cm)</div>
                <div class="sub-header">1:1</div>
            </td>
            <td class="border-bottom-1">{{ getResult('SOLSALTS') }}</td>
        </tr>
        </tbody>
    </table>
</template>

<script type="text/ecmascript-6">
    export default{
        props: {
            sample: { default() { return {} }}
        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {
            getResult (analysis) {
                const value = _.has(this.sample, [analysis, 'value']) ? this.sample[analysis].value : null;
                return value > 0 ? value : null;
            }
        },
        mounted () {

        }
    }
</script>



// WEBPACK FOOTER //
// FirstForm.vue?d86f41aa